import { RefAttributes, ForwardRefExoticComponent } from "react";
import clsx from "clsx";
import { LucideProps } from "lucide-react";

type IconType = ForwardRefExoticComponent<
  Omit<LucideProps, "ref"> & RefAttributes<SVGSVGElement>
>;

export const SheetSectionHeader = ({
  icon: Icon,
  isEmpty,
  title,
}: {
  icon: IconType;
  isEmpty?: boolean;
  title: string;
}) => {
  return (
    <div
      className={clsx(
        "flex items-center gap-2",
        isEmpty ? "text-slate-500" : "text-slate-700",
      )}
    >
      <Icon className="h-4 w-4" />
      <p className="text-lg font-semibold">{title}</p>
    </div>
  );
};
